import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import {
  Box,
  Button,
  Grid,
  TextField,
  Container,
  Paper,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip
} from "@mui/material";
import { Helmet } from "react-helmet";
import ProgrammingLang from "./ProgrammingLang";
import Applications from "./Applications";
import Tools from "./ToolsVersion";
import Notify from "./Alert";
import Validerror from "./Error";
import SystemTools from "./SystemToolsVersion";
import DataMissingError from "./DataMissingError";
import ValidPortsError from "./ValidPortsError";
import MinPortError from "./MinPortError";


const commonStyles = {
  bgcolor: "background.paper",
  m: 1,
  display: "flex",
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 2,
  paddingBottom: 2,
  borderRadius: 1,
};

export default function Configurations(props) {
  const { onState, value, activeStep, handleBack, handleNext, classes } = props;        
  const [errorserver, setErrorserver] = React.useState();
  const [validerroropen, setvaliderroropen] = React.useState(false);  
  const [validerropen1, setvaliderropen1] = React.useState(false);
  

  const [validerropen2, setvaliderropen2] = React.useState(false);
  const [validerropen3, setvaliderropen3] = React.useState(false);

  const [validports, setValidports] = React.useState(false);
  const [minports, setMinports] = React.useState(false);

  const [missingerroropen, setmissingerroropen] = React.useState(false);
  const [alertstate, setAlertstate] = React.useState(false);
  const [showErrors, setShowErrors] = React.useState(false);
  const [state, setState] = React.useState({
    ostype: "",
    instance_type: "",
    linux_type: "",
    windows_type: "",
    port: "",
    instance_storage: "",
  });
  

  const [programmingapps, setProgrammingapps] = React.useState([]);
  const [Systemtools, setSystemtools] = React.useState([]);

  const [normalapps, setNormalapps] = React.useState([]);
  const [devopsapps, setDevopsapps] = React.useState([]);

  const [devopsport, setDevopsport] = React.useState([]);
  const [normalport, setNormalport] = React.useState([]);

  const [temporary, settemporary] = React.useState([]);

  const handleChange = (e) => {    
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  
  const handleReload = () => {
    window.location.reload();
  };

  const [checkstate, setCheckstate] = React.useState({});
  const handlecheckChange = (event) => {
    setCheckstate({ ...checkstate, [event.target.name]: event.target.checked });
  };

  const [instancetype, setInstancetype] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/svminstancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);
  // console.log("Instance type----> ", instancetype)

  const handleSubmitClick = (e) => {
    setShowErrors(true);
    e.preventDefault();    
      var newObj = {};
      var newObj1 = {};

      let count = 0;
      let empty = 0;
      let portlen = 0;
      let validportlen = 0;
      let verify_type = "";

      const appNormalValue = "apps";
      const appProgrammingValue = "programming";
      const appToolsValue = "tools";
      const appSystemToolsValue = "system_tools";     
      
      newObj["instance_type"] = state.instance_type;
      newObj1["instance_type"] = state.instance_type;

      newObj["ostype"] = state.ostype;
      if (state.ostype === "linux") {
        newObj["linux_type"] = state.linux_type;
      } else {
        newObj["windows_type"] = state.windows_type;
      }

      newObj1["ostype"] = state.ostype;
      if (state.ostype === "linux") {
        newObj1["linux_type"] = state.linux_type;
      } else {
        newObj1["windows_type"] = state.windows_type;
      }

      newObj["instance_storage"] = state.instance_storage;
      newObj1["instance_storage"] = state.instance_storage;


      if (state.ostype === "linux") {
        verify_type =  state.linux_type;
      } else {
        verify_type = state.windows_type;
      }

      if (typeof(verify_type) === 'undefined'){
        empty = empty + 1;
        setmissingerroropen(true);
      }
      else{
        setmissingerroropen(false);
      }

      if (state.port === '' ){
        empty = empty + 1;
        setmissingerroropen(true);
      }

      const customlistedports = state.port.split(",").map((pts) => {
        return `${pts}`;
      });

      const portArray = state.port.split(",");
      const setOfPorts = new Set(portArray);
      

      const selectedcustomportslen = customlistedports.length;

      let result = [];

      for (let i = 0; i < customlistedports.length; i++) {
        const regexExp =
          /^((6553[0-5])|(655[0-2][0-9])|(65[0-4][0-9]{2})|(6[0-4][0-9]{3})|([1-5][0-9]{4})|([0-5]{0,5})|([0-9]{1,4}))$/gi;
        const portvalidation = regexExp.test(customlistedports[i]); // true
        if (portvalidation === true) {
          result.push(portvalidation);
        }
      }
      const validportslen = result.length;

      const selectedcustomports = JSON.stringify(customlistedports).replace(
        /"/g,
        ""
      );
      newObj["port"] = selectedcustomports;

      if (state.instance_type === "" || state.ostype === "" || state.instance_storage === "" || state.port === "") {
        empty = empty + 1;
        setmissingerroropen(true);
      }

      if (selectedcustomportslen !== validportslen){
        validportlen = validportlen + 1;
        setValidports(true);
      }
      else if (portArray.length !== setOfPorts.size) {
        setValidports(true);
        // Duplicates exist
        // console.log("Duplicates found!");
        // // You can also get the list of duplicate values if needed
        const duplicates = portArray.filter((item, index) => portArray.indexOf(item) !== index);
        if (duplicates.length > 0){
          setValidports(true);
        }
        // console.log("Duplicate values:", duplicates);
        
      }

      if (selectedcustomportslen > 4){
        portlen = portlen + 1;
        setMinports(true);
      }

      // if (portArray.length !== setOfPorts.size) {
      //   setValidports(true);
      //   // Duplicates exist
      //   console.log("Duplicates found!");
      //   // You can also get the list of duplicate values if needed
      //   const duplicates = portArray.filter((item, index) => portArray.indexOf(item) !== index);
      //   console.log("Duplicate values:", duplicates);
        
      // } else {
      //   // No duplicates
      //   console.log("No duplicates found.");
      // }
      
      if (normalapps["apps"]) {
        // const listofnrmlapps = normalapps["apps"].map((b) => {
        //   return `${b}`;
        // });

        // const selectedNormalApps = JSON.stringify(listofnrmlapps).replace(
        //   /"/g,
        //   ""
        // );
        // newObj[appNormalValue] = selectedNormalApps;
        const listofnrmlapps = normalapps["apps"].map((b) => `"${b}"`);
        newObj[appNormalValue] = `[${listofnrmlapps.join(",")}]`;


        // console.log("------------------------selected apps----------------->", newObj[appNormalValue])
        
        // if (devopsapps["tools"]) {
        //   normalport["apps"].map((na) => {
        //     devopsport["tools"].map((db) => {
        //       if (parseInt(na) === parseInt(db)) {
        //         setErrorserver();
        //       }
        //     });
        //   });
        // }
      } else {
        newObj[appNormalValue] = "notapply";
      }

      if (programmingapps["programming"]) {
        // const listofprogrammingapps = programmingapps["programming"].map(
        //   (b) => {
        //     return `${b}`;
        //   }
        // );
        // const selectedProgrammingApps = JSON.stringify(listofprogrammingapps
        // ).replace(/"/g, "");
        // newObj[appProgrammingValue] = selectedProgrammingApps;

        const listofprogrammingapps = programmingapps["programming"].map((b) => `"${b}"`);
        newObj[appProgrammingValue] = `[${listofprogrammingapps.join(",")}]`;

      } else {
        newObj[appProgrammingValue] = "notapply";
      }

      if (devopsapps["tools"]) {
        newObj[appToolsValue] = devopsapps["tools"];
      } else {
        newObj[appToolsValue] = "notapply";
      }

      if (Systemtools["system_tools"]) {
        // const listofsystemtools = Systemtools["system_tools"].map((b) => {
        //   return `${b}`;
        // });

        // const selectedSystemtools = JSON.stringify(listofsystemtools).replace(
        //   /"/g,
        //   ""
        // );
        // newObj[appSystemToolsValue] = selectedSystemtools;

        const listofsystemtools = Systemtools["system_tools"].map((b) => `"${b}"`);
        newObj[appSystemToolsValue] = `[${listofsystemtools.join(",")}]`;

      } else {
        newObj[appSystemToolsValue] = "notapply";
      }

      if (empty > 0) {
        setvaliderropen1(true);
      } else if(count > 0){        
        setvaliderroropen(true);         
       }
       else if(validportlen > 0){        
        setvaliderropen2(true);         
       }
       else if(portlen > 0){        
        setvaliderropen3(true);         
       }
        else {
          if (normalapps["apps"]) {
            const listofnrmlapps = normalapps["apps"].map((b) => {
              return `${b}`;
            });
            newObj1["apps"] = listofnrmlapps;
          } else {
            newObj1["apps"] = "notapply";
          }

          if (programmingapps["programming"]) {
            const listofprogrammingapps = programmingapps["programming"].map(
              (b) => {
                return `${b}`;
              }
            );
            newObj1["programming"] = listofprogrammingapps;
          } else {
            newObj1["programming"] = "notapply";
          }

          if (devopsapps["tools"]) {
            newObj1[appToolsValue] = devopsapps["tools"];
          } else {
            newObj1[appToolsValue] = "notapply";
          }

          if (Systemtools["system_tools"]) {
            const listofsystemtools = Systemtools["system_tools"].map((b) => {
              return `${b}`;
            });
            newObj1["system_tools"] = listofsystemtools;
          } else {
            newObj1["system_tools"] = "notapply";
          }                    
          const selectedcustomports = JSON.stringify(customlistedports).replace(
            /"/g,
            ""
          );
          newObj1["port"] = selectedcustomports;

          var value = newObj;
          var value1 = newObj1;
                           
          const id1 = "customized_variable";
          const id2 = "billing_info";         

          onState((prevState) => ({
            ...prevState,
            [id1]: value,
            [id2]: value1,
          }));          
          handleNext();
        }      
  };
  const [confirmation, setconfirmation] = React.useState(false);

  const handleClickConfirmation = () => {
    setShowErrors(true);
    setconfirmation(true);
  };

  const handleCloseConfirmation = () => {
    setconfirmation(false);
  };

  const hasDuplicatePorts = (portString) => {
    const ports = portString.split(',').map(p => p.trim()).filter(p => p);
    const seen = new Set();
    for (const port of ports) {
      if (seen.has(port)) return true;
      seen.add(port);
    }
    return false;
  };

  const handleChangePort = (e) => {
    const { id, value } = e.target;
  
    // Allow only numbers and commas
    let filteredValue = value.replace(/[^0-9,]/g, '');
  
    const portList = filteredValue
      .split(',')
      .map(p => p.trim())
      .filter(p => p); // remove empty strings
  
    // Limit to 4 ports
    if (portList.length > 4) {
      filteredValue = portList.slice(0, 4).join(',');
    }
  
    // Check for duplicates
    const duplicates = portList.filter((item, index) => portList.indexOf(item) !== index);
    if (duplicates.length > 0) {
      alert(`Duplicate port(s) detected: ${[...new Set(duplicates)].join(', ')}`);
    }
  
    setState((prevState) => ({
      ...prevState,
      [id]: filteredValue,
    }));
  
    settemporary((prevState) => ({
      ...prevState,
      [id]: filteredValue,
    }));
  };
  

 
  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Box
        sx={{pb: 2}}>
        {alertstate ? <Notify setAlertstate={setAlertstate} /> : ""}
        <Container maxWidth={false}>
                  
            <Validerror
              errorserver={errorserver}
              validerroropen={validerroropen}
              setvaliderroropen={setvaliderroropen}
            /> 

            <DataMissingError 
               validerropen1={missingerroropen}
               setvaliderropen1={setmissingerroropen}
            />

            <ValidPortsError 
               validerropen2={validports}
               setvaliderropen2={setValidports}
            /> 

            <MinPortError 
               validerropen3={minports}
               setvaliderropen3={setMinports}
            />          
              <Box sx={{ pb: 2 }}>
                
                <Typography variant="h6" gutterBottom>
                  Configuration
                </Typography>                               
              </Box>
              <Paper sx={{ ...commonStyles, variant: "outlined" }}>

                
                <Grid container spacing={4}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Instance Type"
                      name={`instance_type`}
                      id={`instance_type`}
                      onChange={handleChange}
                      value={state.instance_type}
                      required
                      autoComplete="name"
                      select
                      SelectProps={{ native: true }}
                      error={Boolean(showErrors && !state.instance_type)}
                      helperText={showErrors && !state.instance_type ? "Instance type is required" : undefined}
                    >
                      {" "}
                      <option key="" value=""></option>
                      {instancetype.map((instancetype) => {
                        return (
                          <React.Fragment>
                            <option value={instancetype.name}>
                              {instancetype.title}
                            </option>
                          </React.Fragment>
                        );
                      })}
                    </TextField>
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Instance_storage"
                      name={`instance_storage`}
                      id={`instance_storage`}
                      onChange={handleChange}
                      value={state.instance_storage}
                      required
                      select
                      SelectProps={{ native: true }}
                      autoComplete="name"
                      error={Boolean(showErrors && !state.instance_storage)}
                      helperText={showErrors && !state.instance_storage ? "Storage is required" : undefined}
                    >
                      {" "}
                      <option key="" value=""></option>
                      <option key="200" value="200">
                        200gb
                      </option>
                      <option key="500" value="500">
                        500gb
                      </option>
                    </TextField>
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="OS-Type"
                      name={`ostype`}
                      id={`ostype`}
                      onChange={handleChange}
                      value={state.ostype}                      
                      required
                      select
                      SelectProps={{ native: true }}
                      autoComplete="name"
                      error={Boolean(showErrors && !state.ostype)}
                      helperText={showErrors && !state.ostype ? "OS type is required" : undefined}
                    >
                      {" "}
                      <option key="" value=""> </option>
                      <option key="linux" value="linux">
                        Linux
                      </option>
                      <option key="windows" value="windows">
                        Windows
                      </option>
                    </TextField>
                  </Grid>

                  {state.ostype === "linux" ? (
                    <React.Fragment>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Linux-Type"
                          name={`linux_type`}
                          id={`linux_type`}
                          onChange={handleChange}
                          value={state.linux_type}
                          required
                          select
                          SelectProps={{ native: true }}
                          autoComplete="name"
                          error={Boolean(showErrors && !state.linux_type)}
                          helperText={showErrors && !state.linux_type ? "Linux type is required" : undefined}
                        >
                          {" "}
                          <option key="" value=""></option>
                          <option key="centos7" value="centos7">
                            Centos7
                          </option>
                          <option key="centos8" value="centos8">
                            Centos8
                          </option>
                          {/* <option key="ubuntu16" value="ubuntu16">
                            Ubuntu16
                          </option> 
                          <option key="ubuntu18" value="ubuntu18">
                            Ubuntu18
                          </option> */}
                          <option key="ubuntu20" value="ubuntu20">
                            Ubuntu20
                          </option>
                          <option key="ubuntu22" value="ubuntu22">
                            Ubuntu22
                          </option>
                          <option key="ubuntu24" value="ubuntu24">
                            Ubuntu24
                          </option>
                        </TextField>
                      </Grid>
                      {state.linux_type === "centos7" ? (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="centos7"
                                appsetFormFields={setNormalapps}
                                setNormalport={setNormalport}
                                appfieldIndex="apps"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="centos7"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="centos7"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Tools
                                OSTYPE="centos7"
                                appsetFormFields={setDevopsapps}
                                appfieldIndex="tools"
                                setDevopsport={setDevopsport}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : state.linux_type === "centos8" ? (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="centos8"
                                appsetFormFields={setNormalapps}
                                appfieldIndex="apps"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="centos8"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="centos8"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Tools
                                OSTYPE="centos8"
                                appsetFormFields={setDevopsapps}
                                appfieldIndex="tools"
                                setDevopsport={setDevopsport}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : state.linux_type === "ubuntu18" ? (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="ubuntu18"
                                appsetFormFields={setNormalapps}
                                setNormalport={setNormalport}
                                appfieldIndex="apps"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="ubuntu18"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="ubuntu18"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Tools
                                OSTYPE="ubuntu18"
                                appsetFormFields={setDevopsapps}
                                setDevopsport={setDevopsport}
                                appfieldIndex="tools"
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : state.linux_type === "ubuntu20" ? (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="ubuntu20"
                                appsetFormFields={setNormalapps}
                                setNormalport={setNormalport}
                                appfieldIndex="apps"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="ubuntu20"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="ubuntu20"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Tools
                                OSTYPE="ubuntu20"
                                appsetFormFields={setDevopsapps}
                                setDevopsport={setDevopsport}
                                appfieldIndex="tools"
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : state.linux_type === "ubuntu22" ? (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="ubuntu22"
                                appsetFormFields={setNormalapps}
                                setNormalport={setNormalport}
                                appfieldIndex="apps"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="ubuntu22"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="ubuntu22"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Tools
                                OSTYPE="ubuntu22"
                                appsetFormFields={setDevopsapps}
                                setDevopsport={setDevopsport}
                                appfieldIndex="tools"
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="ubuntu24"
                                appsetFormFields={setNormalapps}
                                setNormalport={setNormalport}
                                appfieldIndex="apps"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="ubuntu24"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="ubuntu24"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Tools
                                OSTYPE="ubuntu24"
                                appsetFormFields={setDevopsapps}
                                setDevopsport={setDevopsport}
                                appfieldIndex="tools"
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </React.Fragment>
                  ) : state.ostype === "windows" ? (
                    <React.Fragment>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          label="Windows-Type"
                          name={`windows_type`}
                          id={`windows_type`}
                          onChange={handleChange}
                          value={state.windows_type}
                          required
                          select
                          SelectProps={{ native: true }}
                          autoComplete="name"
                          error={Boolean(showErrors && !state.windows_type)}
                          helperText={showErrors && !state.windows_type ? "Windows type is required" : undefined}
                        >
                          {" "}
                          <option key="" value=""></option>
                          <option key="windows10" value="windows10">
                            Windows10
                          </option>
                          <option key="windows2022" value="windows2022">
                            Windows2022
                          </option>
                        </TextField>
                      </Grid>
                      {state.windows_type === "windows10" ? (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="windows10"
                                appsetFormFields={setNormalapps}
                                setNormalport={setNormalport}
                                appfieldIndex="apps"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="windows10"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="windows10"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid item xs={12}>
                          <Grid container spacing={4}>
                            <Grid item xs={6}>
                              <Applications
                                OSTYPE="windows2022"
                                appsetFormFields={setNormalapps}
                                setNormalport={setNormalport}
                                appfieldIndex="apps"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <ProgrammingLang
                                OSTYPE="windows2022"
                                appsetFormFields={setProgrammingapps}
                                appfieldIndex="programming"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <SystemTools
                                OSTYPE="windows2022"
                                appsetFormFields={setSystemtools}
                                appfieldIndex="system_tools"
                                setNormalport={setNormalport}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </React.Fragment>
                  ) : (
                    ""
                  )}

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Port"
                      name="port"
                      helperText={
                        showErrors && (!state.port || !/^\s*(all|[0-9]+(\s*,\s*[0-9]+)*)\s*$/.test(state.port))
                          ? "Enter 'all' or comma-separated port numbers"
                          : "Enter valid ports separated by commas (Max: 4 ports)"
                      }
                      id="port"
                      onChange={handleChangePort}
                      onKeyDown={(e) => {
                        // Allow: numbers (0-9), comma, backspace, delete, tab, arrow keys
                        const allowedKeys = [
                          'Backspace', 'Delete', 'Tab', 
                          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                          ','
                        ];
                        
                        // Get current input value
                        // const currentValue = e.target.value.toLowerCase();
                        
                        // Special case: allow typing "all"
                        // if (['a', 'l'].includes(e.key.toLowerCase())) {
                        //   // Only allow if it's part of typing "all"
                        //   if (currentValue === '' && e.key.toLowerCase() === 'a') return;
                        //   if (currentValue === 'a' && e.key.toLowerCase() === 'l') return;
                        //   if (currentValue === 'al' && e.key.toLowerCase() === 'l') return;
                        // }
                        
                        // Block if not number, comma, or allowed key
                        if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={state.port}
                      required
                      autoComplete="off"
                      error={Boolean(showErrors && (!state.port || !/^\s*(all|[0-9]+(\s*,\s*[0-9]+)*)\s*$/.test(state.port))) || hasDuplicatePorts(state.port)}
                    />
                  </Grid>
                </Grid>
              </Paper>
              </Container>
              </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and reset this step">
            <span>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleReload}
                className={classes}
                sx={{ borderRadius: '50px' }}
              >
                Cancel
              </Button>
            </span>
          </Tooltip>
        </div>
        <div className={classes}>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step">
              <span>
                <Button onClick={handleBack} variant="contained" className={classes} sx={{ borderRadius: '50px', mr: 0.5 }}>
                  Back
                </Button>
              </span>
            </Tooltip>
          )}
          {checkstate.checkedB ? (
            <Tooltip title={result > 0 ? "Proceed to the next step" : "Please complete all required fields"}>
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClickConfirmation}
                  className={classes}
                  disabled={result > 0 ? false : true}
                  sx={{ borderRadius: '50px' }}
                >
                  Next
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Tooltip title="Proceed to the next step">
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmitClick}
                  className={classes}
                  sx={{ borderRadius: '50px' }}
                >
                  Next
                </Button>
              </span>
            </Tooltip>
          )}
        </div>
      </Box>
      <div style={{ alignItems: "center", display: "flex", width: "600px" }}>
        <Dialog
          open={confirmation}
          onClose={handleCloseConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            The below applied specifications will get reflected on your machine{" "}
            <strong style={{ color: "#EF5350" }}>
              {localStorage.getItem("specifyusername")}
            </strong>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel and close dialog">
              <span>
                <Button onClick={handleCloseConfirmation} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
                  Cancel
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="Apply specifications">
              <span>
                <Button onClick={handleSubmitClick} variant="contained" color="primary" autoFocus sx={{ borderRadius: '50px' }}>
                  Apply
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>          
  );
}
